import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import { useToast } from "../hooks/use-toast";

const ProductCard = ({ product }) => {
  const isService = product.type === "service";
  const variants = product.variants && product.variants.length ? product.variants : null;
  const showFrom = isService && variants && variants.length > 1;
  const displayPrice = variants ? variants[0].price : product.price;
  const { isFav, toggle } = useWishlist();
  const { toast } = useToast();
  const navigate = useNavigate();

  const onHeart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const res = await toggle(product.id);
    if (res?.needLogin) {
      toast({ title: "Sign in to save favourites", description: "Create a free account with Google." });
      navigate("/login");
      return;
    }
    toast({ title: res.added ? "Saved to wishlist" : "Removed from wishlist" });
  };

  const fav = isFav(product.id);

  return (
    <Link to={`/product/${product.id}`} className="card-zoom group block">
      <div className="relative aspect-square overflow-hidden rounded-xl bg-white border border-[#0e2a1e]/8">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
        {!isService && typeof product.stock === "number" && product.stock <= 0 && (
          <div className="absolute inset-0 bg-white/60 flex items-center justify-center">
            <span className="bg-[#0e2a1e] text-[#f4f2ea] text-xs font-semibold px-3 py-1.5 rounded-full">Out of stock</span>
          </div>
        )}
        <button
          onClick={onHeart}
          aria-label="Toggle wishlist"
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center hover:scale-110 transition-transform"
        >
          <Heart size={18} className={fav ? "text-red-500 fill-red-500" : "text-[#0e2a1e]"} />
        </button>
      </div>
      <div className="mt-3">
        {isService && product.tagline && (
          <span className="text-[11px] font-semibold uppercase tracking-wide text-[#2f6b1e]">
            {product.tagline}
          </span>
        )}
        <h3 className="text-sm font-medium text-[#0e2a1e] group-hover:text-[#a4820e] transition-colors">
          {product.name}
        </h3>
        <p className="text-sm text-[#0e2a1e]/70 mt-1">
          {showFrom ? "from " : ""}${displayPrice.toFixed(2)}
        </p>
      </div>
    </Link>
  );
};

export default ProductCard;
